<div>
  <button
    pButton
    type="button"
    label="Back to Inbox"
    [routerLink]="['/', this.slug, 'patient', 'messagecenter']"
  ></button>
</div>

<div class="ui-g-12">
  <div class="card no-margin">
    <form
      #messageForm="ngForm"
      (ngSubmit)="sendMessage()"
      accept-charset="UTF-8"
    >
      <p-fieldset>
        <p-header><b>Compose Email</b></p-header>
        <div class="row">
          <label for="from" class="notranslate">From</label><br /><br />
          <p-dropdown
            [(ngModel)]="message.patient_guid"
            [options]="members"
            class="notranslate"
            name="patient"
            (onChange)="onMemberChange()"
            #patient="ngModel"
            [disabled]="posting"
            required
          >
          </p-dropdown>
          <div
            *ngIf="patient.invalid && (patient.dirty || patient.touched)"
            class="alert alert-danger"
          >
            <div *ngIf="patient.errors.required">Choose a member.</div>
          </div>
        </div>
        <br />
        <div class="row">
          <label for="To" class="notranslate">To</label><br /><br />
          <p-dropdown
            [(ngModel)]="message.user_guid"
            [options]="doctor_list"
            class="notranslate"
            name="doctors"
            #doctors="ngModel"
            [disabled]="posting"
            required
          ></p-dropdown>
          <div
            *ngIf="doctors.invalid && (doctors.dirty || doctors.touched)"
            class="alert alert-danger"
          >
            <div *ngIf="doctors.errors.required">Choose a doctor.</div>
          </div>
        </div>
        <br />

        <div class="row">
          <div>
            <label for="Subject">Subject</label><br /><br />
            <input
              id="Subject"
              type="text"
              pInputText
              [pKeyFilter]="textarea"
              placeholder="Subject"
              [(ngModel)]="message.subject"
              name="subjectmodel"
              [maxlength]="max_subject_length"
              #subjectmodel="ngModel"
              required
            />
            <br />
            <p
              [style.color]="
                message.subject.length - max_subject_length - 1 > 0
                  ? 'red'
                  : 'green'
              "
            >
              {{
                max_subject_length + 1 - message.subject.length < 0
                  ? 0
                  : max_subject_length - message.subject.length
              }}
              of {{ max_subject_length }} characters left
            </p>
            <div
              *ngIf="
                subjectmodel.invalid &&
                (subjectmodel.dirty || subjectmodel.touched)
              "
              class="alert alert-danger"
            >
              <div *ngIf="subjectmodel.errors.required">
                Subject is required.
              </div>
            </div>
          </div>
        </div>
        <br />

        <div class="col-sm-10">
          <textarea
            pInputTextarea
            [pKeyFilter]="textarea"
            [autoResize]="true"
            [(ngModel)]="message.message"
            name="messagemodel"
            placeholder="Enter your message here"
            #messagemodel="ngModel"
            [maxlength]="max_message_length"
            style="height: 40%"
            required
          ></textarea>

          <p
            [style.color]="
              message.message.length - max_message_length - 1 > 0
                ? 'red'
                : 'green'
            "
          >
            {{
              max_message_length + 1 - message.message.length < 0
                ? 0
                : max_message_length - message.message.length
            }}
            of {{ max_message_length }} characters left
          </p>
          <div
            *ngIf="
              messagemodel.invalid &&
              (messagemodel.dirty || messagemodel.touched)
            "
            class="alert alert-danger"
          >
            <div *ngIf="messagemodel.errors.required">Message is required.</div>
          </div>
        </div>
        <br />

        <div class="row">
          <button
            pButton
            type="submit"
            label="Send"
            icon="fa fa-send m-l-5"
            [disabled]="!messageForm.valid || posting"
            style="margin-right: 1%"
          ></button>
          <button
            pButton
            type="button"
            label="Discard"
            icon="fa fa-trash-o m-l-5"
            style="margin: 1%"
          ></button>
        </div>
        <br />
        <p-progressSpinner
          [style]="{ width: '50px', height: '50px' }"
          *ngIf="posting"
          strokeWidth="6"
        >
        </p-progressSpinner>
        <div
          *ngIf="response.success != null && response.success == false"
          class="alert alert-danger"
        >
          <p *ngIf="response.error != null">{{ response.error.message }}</p>
          <div *ngIf="serverError != null">
            <div
              *ngIf="serverError.error != null && serverError.statusCode != 500"
            >
              <p *ngFor="let message of serverError.message">{{ message }}</p>
            </div>
            <div
              *ngIf="
                serverError.error != null && serverError.statusCode === 500
              "
            >
              <p>{{ serverError.message }}</p>
            </div>
          </div>
        </div>
        <div
          *ngIf="response.success != null && response.success == true"
          style="color: green"
        >
          <p>Your message has been sent</p>
        </div>
      </p-fieldset>
    </form>
  </div>
</div>
